<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2024-12-26 16:13:00
 * @LastEditors: lc
 * @LastEditTime: 2025-03-05 10:21:36
-->
<template>
  <div class="studymodulefile-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           stripe
           :columns="columns1"
           ref="selection"
           :data="typelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加 弹层 -->
    <Drawer title="信息"
            v-model="showCreatTypeModal"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="cate"
            ref="addCate"
            :rules="cateValidate"
            action="javascript:void(0)">
        <FormItem label="名称"
                  prop="name">
          <Input v-model="cate.name"
                 placeholder />
        </FormItem>
        <FormItem label="封面图">
          <upload-thumb v-model="cate.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="120"
                        :autoCropHeight="120"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:120*120,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="文件类型"
                  prop="type">
          <Select v-model="cate.type"
                  filterable
                  clearable
                  placeholder="请选择文件类型">
            <Option v-for="(item,index) in type_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id" />
          </Select>
        </FormItem>
        <FormItem label="选择文件"
                  prop="filePath"
                  v-if="cate.type==1">
          <file-import v-model="cate.file"
                       :defaultList="fileList"
                       ref="import-files"></file-import>
        </FormItem>
        <FormItem label="视频"
                  prop="url"
                  v-if="cate.type==2">
          <upload-video ref="uploadvideo"
                        v-model="cate.file"
                        :defaultList="videoList"></upload-video>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showCreatTypeModal = false">取消</Button>
        <Button type="primary"
                :loading="tijiaoloading"
                @click="createType('addCate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>
      
      <script>
import UploadThumb from "../common/thumb";
import FileImport from "../common/fileimport";
import UploadVideo from "../common/videochapter";
export default {
  name: "studymodulefile-list",
  data () {
    return {
      loading: true,
      dataloading: true,
      tijiaoloading: false,
      fileList: [],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      type_list: [{ id: 1, name: '文件' }, { id: 2, name: '视频' }],
      // 类别
      cate: {
        name: "", // 当前类别
        thumb: "", // 排序
        type: 1
      },
      formItem: {},
      thumblist: [],
      videoList: [],
      // 类别 规则
      cateValidate: {
        name: [
          {
            required: true,
            message: "名称必须填写",
            trigger: "blur"
          }
        ]
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "名称",
          minWidth: 120,
          key: "name",
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  marginLeft: params.row.left + "px"
                }
              },
              params.row.name
            );
          }
        },
        {
          title: "文件类型",
          minWidth: 120,
          key: "type",
        },
        {
          title: "操作",
          key: "action",
          minWidth: 130,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editType(params.row.id);
                    }
                  }
                },
                "修改"
              ),

              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeType(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      typelist: [], //类别列表
      showCreatTypeModal: false,
      currentId: 0, // 编辑类别，当前类别id
      moduleid: 0,
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    this.moduleid = this.$route.params.id;
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb,
    FileImport,
    UploadVideo
  },
  methods: {
    // 获取类别列表
    getTableList: function () {
      var self = this;
      var params = {
        page: this.pages.page,
        size: this.pages.size,
        module_id: this.moduleid,
      };
      this.$api.studymodulefile.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.typelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var params = {
        page: this.pages.page,
        size: this.pages.size,
        module_id: this.moduleid,
      };
      this.$api.studymodulefile.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.typelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 添加
    addGoodCate: function () {
      this.currentId = 0;
      this.cate = {
        name: "",
        thumb: "",
        file: "",
        type: 1
      };
      this.thumblist = new Array();
      this.fileList = new Array();
      this.videoList = [];
      this.tijiaoloading = false;
      this.showCreatTypeModal = true;
    },
    // 编辑类别
    editType: function (id) {
      this.currentId = id;
      this.showCreatTypeModal = true;
      this.tijiaoloading = false;
      this.thumblist = new Array();
      this.fileList = new Array();
      this.$api.studymodulefile.detail({ id: id }).then(res => {
        if (res.code == 200) {
          this.cate.name = res.result.name;
          this.cate.thumb = res.result.thumb;
          this.cate.type = res.result.type;
          if (this.cate.thumb != null && this.cate.thumb != "") {
            this.thumblist.push({
              name: this.cate.thumb,
              url: this.cate.thumb,
              status: "finished"
            });
          }
          if (res.result.file != null) {
            if (res.result.type == 1) {
              this.fileList.push({
                name: res.result.file,
                url: res.result.file,
                status: "finished"
              });
            } else {
              this.videoList.push({
                name: res.result.file,
                url: res.result.file,
                fullurl: this.$publicData.ossUrl + res.result.file,
                status: "finished"
              });
              this.$refs["uploadvideo"].uploadStatus = false;
            }

          }
        }
      });
    },
    // 提交新类别
    createType: function (name) {
      this.tijiaoloading = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.cate.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.cate.thumb = null;
          }
          if (this.cate.type == 1) {
            if (this.$refs["import-files"].resList.length > 0) {
              if (
                this.$refs["import-files"].resList[0].response &&
                this.$refs["import-files"].resList[0].response.result &&
                this.$refs["import-files"].resList[0].response.result.url != ""
              ) {
                this.cate.file = this.$refs["import-files"].resList[0].response.result.url;
              } else {

                this.cate.file = this.$refs["import-files"].resList[0].url;
              }
            } else {
              this.cate.file = ""
            }
          } else {
            if (this.$refs["uploadvideo"].videoList.length > 0) {
              this.cate.file = this.$refs["uploadvideo"].videoList[0].url;
            } else {
              this.cate.file = null;
            }
          }
          let params = {
            thumb: this.cate.thumb,
            name: this.cate.name, // 分类名称
            file: this.cate.file,
            module_id: this.moduleid,
            type: this.cate.type,
          };
          if (this.currentId == null || this.currentId == 0) {
            this.tijiaoloading = false;
            this.$api.studymodulefile.create(params).then(res => {
              if (res.code == 200) {
                this.showCreatTypeModal = false;
                this.getTableList();
              }
            });
          } else {
            params.id = this.currentId;
            this.$api.studymodulefile.edit(params).then(res => {
              this.tijiaoloading = false;
              if (res.code == 200) {
                this.showCreatTypeModal = false;
                this.getTableList();
              }
            });
          }
          this.tijiaoloading = false;
          this.$nextTick(() => {
            this.tijiaoloading = true;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.tijiaoloading = false;
          this.$nextTick(() => {
            this.tijiaoloading = true;
          });
        }
      });
      this.tijiaoloading = false;
    },
    // 删除
    removeType: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>是否确定删除该类别？</p>",
        onOk: () => {
          this.$api.studymodulefile
            .remove({
              id: id
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
  }
};
      </script>